
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { EstimateService } from '../poker-room/estimate.service';
import { AuthService } from '../user/auth.service';
import { NGXLogger as LoggerService } from "ngx-logger";
import { ResponsiveService } from './responsive.service';

//declare const window: any;
declare global {
    interface Window {
        fusetag: any;
        enableFooterSticky: boolean
    }
}
const fuseIdsMobile = [
    '22851570040',
    '22851418830',
];

const fuseIdsDesktop = [
    '22851570049',
    '22851570043',
    '22851570046',
    '22851569437',
];


const fuseScriptUrl = "https://cdn.fuseplatform.net/publift/tags/2/2981/fuse.js"
const fuseScriptStaging = `// Fuse script for staging only
window.googletag = window.googletag || { cmd: [] };
googletag.cmd?.push(function () {
googletag.pubads().set("page_url", "scrumpoker-online.org");
});`

// ezoic: https://docs.ezoic.com/docs/ezoicads/implementation/
/*
Add the Ezoic Privacy Scripts and Header Script at the very top of the <head> tag. Please ensure you load the privacy scripts before the header script.
<script src="https://cmp.gatekeeperconsent.com/min.js" data-cfasync="false"></script>
<script src="https://the.gatekeeperconsent.com/cmp.min.js" data-cfasync="false"></script>
 */
const ezoicPrivacyScript1Url = "https://cmp.gatekeeperconsent.com/min.js"
const ezoicPrivacyScript2Url = "https://the.gatekeeperconsent.com/cmp.min.js"
const ezoicPrivacyScriptAttributeKey = "data-cfasync"
const ezoicPrivacyScriptAttributeValue = "false"
/*Ezoic Header Script
<script async src="//www.ezojs.com/ezoic/sa.min.js"></script>
<script>
    window.ezstandalone = window.ezstandalone || {};
    ezstandalone.cmd = ezstandalone.cmd || [];
</script>
*/

const ezoicHeaderScriptUrl = "https://www.ezojs.com/ezoic/sa.min.js"
const ezoicHeaderScriptText = " window.ezstandalone = window.ezstandalone || {};ezstandalone.cmd = ezstandalone.cmd || [];"
const ezoicShowAdsScript = "ezstandalone.cmd.push(function() {  ezstandalone.showAds()});"
const ezoicShowAdsScriptHomePage = "ezstandalone.cmd.push(function () {ezstandalone.showAds(100);});"

@Injectable()
export class AdvertisingService {
    _isInitialized = false;
    _ezoicHeaderScriptsIntitalized = false
    htmlHead: HTMLHeadElement
    privacyScript2
    constructor(
        private authService: AuthService,
        private logger: LoggerService,
        public responsiveService: ResponsiveService,
        public estimateService: EstimateService,
    ) {
        this.htmlHead = document.getElementsByTagName('head')[0];
    }

    public init() {
        this.logger.warn('init')
        if (!this._isInitialized) { // make sure script loaded only once
            this._isInitialized = true;
            if (this.fuseEnabled) this.initializeFuse()
            if (this.ezoicEnabled) this.initializeEzoic()
        }
    }

    private initializeEzoic() {
        this.logger.log('initializeEzoic')
        const privacyScript1 = this.newScriptNode({ scriptUrl: ezoicPrivacyScript1Url, attributeKey: ezoicPrivacyScriptAttributeKey, attributeValue: ezoicPrivacyScriptAttributeValue })
        this.privacyScript2 = this.newScriptNode({ scriptUrl: ezoicPrivacyScript2Url, attributeKey: ezoicPrivacyScriptAttributeKey, attributeValue: ezoicPrivacyScriptAttributeValue })
        this.htmlHead.insertBefore(privacyScript1, this.htmlHead.firstChild);
        this.insertHtmlElementAfter(this.privacyScript2, privacyScript1);

    }


    newScriptNode(param: { scriptUrl?: string, attributeKey?: string, attributeValue?: string, text?: string }) {
        let scriptNode = document.createElement('script');
        if (param.scriptUrl) scriptNode.src = param.scriptUrl;
        if (param.attributeKey) scriptNode.setAttribute(param.attributeKey, param.attributeValue);
        if (param.text) scriptNode.text = param.text
        return scriptNode
    }


    private insertHtmlElementAfter(newElement: HTMLElement, referenceElement: HTMLElement) {
        const parent = referenceElement.parentNode;
        if (parent) {
            parent.insertBefore(newElement, referenceElement.nextSibling);
        }
    }

    private initializeFuse() {
        this.logger.log('initializeFuse')
        this.setStickyFooterForFuse(false); // off when starting , enable afater entering a room only
        this.logger.log("init Fuse :loadScript")
        this.loadScriptToHeader(fuseScriptUrl)
        if (!environment.production) {
            this.loadFuseScriptForStaging()
        }
    }

    get isNotInPremiumRoom(): boolean {
        return !this.authService.hasPremium() && !this.estimateService.ownerHasPremium
    }

    get fuseEnabled(): boolean {
        return environment.enableFuse && this.isNotInPremiumRoom
    }

    get ezoicEnabled(): boolean {
        return environment.enableEzoic && this.isNotInPremiumRoom
    }

    private loadScriptToHeader(scriptUrl: string) {
        try {
            let node = document.createElement('script');
            node.type = 'text/javascript';
            node.async = true;
            node.src = scriptUrl;
            this.htmlHead.appendChild(node);
        } catch (error) {
            this.logger.error('loadScript domElementId', error)
        }
    }

    private ezoicInitHeaderScripts() {
        if (!this._ezoicHeaderScriptsIntitalized) {
            this.logger.log('ezoicInitHeaderScripts')
            this._ezoicHeaderScriptsIntitalized = true
            const headerScript1 = this.newScriptNode({ scriptUrl: ezoicHeaderScriptUrl, attributeKey: 'async', attributeValue: '' })
            const headerScript2 = this.newScriptNode({ text: ezoicHeaderScriptText })
            this.insertHtmlElementAfter(headerScript1, this.privacyScript2);
            this.insertHtmlElementAfter(headerScript2, headerScript1);
        }
    }

    public async ezoicShowAdsScript(domElementId: string) {
        if (!(await this.estimateService.getOwnerHasPremium()) && this.ezoicEnabled) {
            this.logger.warn('ezoicShowAdsScript owner has NOT premium')
            try {
                this.ezoicInitHeaderScripts()
                let node = document.createElement('script');
                node.text = ezoicShowAdsScript

                document.getElementById(domElementId)?.appendChild(node)
            } catch (error) {
                this.logger.error('loadScriptToDomElement domElementId', domElementId, error)
            }
        } else {
            this.logger.warn('ezoicShowAdsScript owner DOES have  premium')
        }
    }

    public async ezoicShowAdsScriptHomePage(domElementId: string) {
        if (!(await this.estimateService.getOwnerHasPremium()) && this.ezoicEnabled) {
            this.logger.warn('ezoicShowAdsScriptHomePage owner has NOT premium')
            try {
                this.ezoicInitHeaderScripts()
                let node = document.createElement('script');
                node.text = ezoicShowAdsScriptHomePage
                document.getElementById(domElementId)?.appendChild(node)
            } catch (error) {
                this.logger.error('loadScriptToDomElement domElementId', domElementId, error)
            }
        } else {
            this.logger.warn('ezoicShowAdsScriptHomePage owner DOES have  premium')
        }
    }




    private loadFuseScriptForStaging() {
        this.logger.log('loadFuseScriptForStaging')
        try {
            let node = document.createElement('script');
            node.type = 'text/javascript';
            node.text = fuseScriptStaging;
            this.htmlHead?.appendChild(node);
        } catch (error) {
            this.logger.error('loadFuseScriptForStaging', error)
        }


    }


    /**
     *You can control where and when the sticky footer becomes active through the script below. If window.enableFooterSticky = true, then the ad unit is active, if false, then the ad unit is not active.
    Through this condition you can control the sticky ad unit to be active on all non-premium pages. For premium users, you can exclude the script.
    <script type="text/javascript" id="publift-footer-sticky">window.enableFooterSticky = true;</script>
    Because the site is SPA, the script needs to execute before registerZone() and pageInit().
     */
    private setStickyFooterForFuse(stickyFooter: boolean) {
        window.enableFooterSticky = stickyFooter;
    }

    get fuseIds() {
        let fuseIds: string[];
        if (this.responsiveService.isScreenSmall()) {
            fuseIds = fuseIdsMobile
        } else {
            fuseIds = fuseIdsDesktop
        }
        return fuseIds
    }

    public registerFuseTag() {
        const fusetag = window.fusetag || (window.fusetag = { que: [] });
        const fuseIds = this.fuseIds
        if (this.fuseEnabled) {
            this.logger.log('registerFuseTag fuseEnabled ')
            this.setStickyFooterForFuse(true);
            fusetag.que.push(function () {
                fusetag.pageInit({
                    // Defer the first auction until FuseIds are registered
                    blockingFuseIds: fuseIds,
                });
            });
            fuseIds.forEach(id => {
                fusetag.que.push(function () {
                    fusetag.registerZone(id)
                });
            })
        } else {
            this.logger.log('setStickyFooter(false)')
            this.setStickyFooterForFuse(false);
            if (fusetag) {
                fusetag.pageInit()
            }
        }
    }
}
